import { jwtDecode } from 'jwt-decode';
import type { Maybe } from '@bbkAdminUtils/utility-types';
import { recordError } from '@bbkAdminUtils/recordError';

export class JWTParser {
  public static parse<T>(jwt: string): Maybe<T> {
    try {
      return jwtDecode<T>(jwt);
    } catch (err) {
      recordError(jwt);
      recordError(err);
      return undefined;
    }
  }
}
